<template>
  <div style="position: relative">
    <ColumnVisibilitySidebar
      :id="columnSidebarId"
      module-label="pedidos"
      :fields="fields"
      :visible-fields="fieldsToShow"
      @save="handleSaveFields"
    />

    <FilterFields :fields="filterFields" />

    <b-dropdown
      id="menu"
      variant="dark"
      v-b-tooltip.right="'Mais ações'"
      v-if="actionsStore.selectedRows.length > 0"
      style="position: absolute; top: 0; left: 50px"
    >
      <template #button-content>
        <Menu :size="18" />
      </template>
      <b-dropdown-item
        v-b-modal.atualizarStatus
        :disabled="actionsStore.selectedRows.length <= 0"
      >
        Atualizar Status
      </b-dropdown-item>
      <b-dropdown-item
        v-if="!store.pafNFCe && actionsStore.selectedRows[0]?.status != 8"
        v-b-modal.faturarPedido
        :disabled="
          actionsStore.selectedRows.every((p) => p.status == 12)
        "
      >
        Faturar Pedido
      </b-dropdown-item>
      <b-dropdown-item
        v-b-modal.duplicarPedido
        :disabled="actionsStore.selectedRows.length > 1"
      >
        Duplicar Pedido
      </b-dropdown-item>
      <b-dropdown-item
        @click="imprimirPedidoProducao"
        :disabled="actionsStore.selectedRows.length > 1"
      >
        Imprimir pedido para produção
      </b-dropdown-item>
      <b-dropdown-item
        v-if="actionsStore.selectedRows[0]?.status == 12"
        v-b-modal.estornarPedidoModal
        :disabled="actionsStore.selectedRows.length <= 0"
      >
        Estornar Pedido
      </b-dropdown-item>
    </b-dropdown>

    <b-button
      class="border border-muted"
      variant="secondary"
      v-b-tooltip.hover.right="'Customizar colunas'"
      style="position: absolute; right: 0; top: 0"
      @click="$root.$emit('bv::toggle::collapse', columnSidebarId)"
    >
      <ToggleSwitchOutline :size="20" />
    </b-button>

    <b-modal
      id="duplicarPedido"
      title="Deseja duplicar o Pedido selecionado?"
      centered
      size="xs"
    >
      <label
        >Pedido a ser duplicado
        <p>Número: {{ actionsStore.selectedRows[0]?.numero }}</p>
      </label>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="duplicar"
            ref="doublePedido"
            class="mr-5"
          >
            Confirmar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="faturarPedido"
      :title="
        actionsStore.selectedRows.length > 1
          ? 'Deseja faturar os ' +
            actionsStore.selectedRows.length +
            ' pedidos selecionados?'
          : 'Deseja faturar o Pedido?'
      "
      centered
      size="lg"
      scrollable
      @show="inicializarItensFaturamento"
    >
      <!-- CONFIG GLOBAL (aplica-se a todos) -->
      <h6 class="font-weight-bolder text-dark">
        Configuração geral (aplica-se a todos)
      </h6>
      <b-row class="align-items-center mb-3">
        <b-col md="4">
          <p class="font-weight-bolder text-dark mb-2">Movimentar estoque</p>
          <span class="switch switch-icon">
            <label v-b-tooltip.hover.right="'Não/Sim'">
              <input type="checkbox" v-model="movimentar_estoque" />
              <span></span>
            </label>
          </span>
        </b-col>
        <b-col md="4">
          <p class="font-weight-bolder text-dark mb-2">Gerar financeiro</p>
          <span class="switch switch-icon">
            <label v-b-tooltip.hover.right="'Não/Sim'">
              <input type="checkbox" v-model="gerar_financeiro" />
              <span></span>
            </label>
          </span>
        </b-col>
        <b-col md="4">
          <b-form-group
            id="data_faturamento_global"
            label-for="data_faturamento_global"
            label="Data do Faturamento"
          >
            <b-form-input
              v-model="data_faturamento"
              type="date"
              required
            />
          </b-form-group>
        </b-col>
        <b-col md="12" class="text-right">
          <b-button size="sm" variant="light" @click="aplicarGlobalAosItens">
            Aplicar a todos
          </b-button>
        </b-col>
      </b-row>

      <hr />

      <!-- LISTA POR ITEM -->
      <h6 class="font-weight-bolder text-dark mb-2">
        Pedidos selecionados ({{ itensFaturamento.length }})
      </h6>
      <div style="max-height: 320px; overflow-y: auto">
        <b-table
          striped
          hover
          bordered
          small
          :items="itensFaturamento"
          :fields="camposItensFaturamento"
          responsive
        >
          <template #cell(numero)="row">
            <strong>{{ row.item.numero }}</strong>
          </template>
          <template #cell(movimentar_estoque)="row">
            <span class="switch switch-icon">
              <label v-b-tooltip.hover.right="'Não/Sim'">
                <input
                  type="checkbox"
                  v-model="row.item.movimentar_estoque"
                />
                <span></span>
              </label>
            </span>
          </template>
          <template #cell(gerar_financeiro)="row">
            <span class="switch switch-icon">
              <label v-b-tooltip.hover.right="'Não/Sim'">
                <input
                  type="checkbox"
                  v-model="row.item.gerar_financeiro"
                />
                <span></span>
              </label>
            </span>
          </template>
          <template #head(comprovante_pagamento)>
            Comprovante
            <span
              v-b-tooltip.hover.bottom="'PDF, JPG/JPEG ou PNG de até 10 MB. O arquivo será anexado às parcelas deste pedido no Contas a Receber.'"
              class="ml-1 text-primary cursor-pointer"
            >
              <InformationOutline :size="16" />
            </span>
          </template>
          <template #cell(comprovante_pagamento)="row">
            <input
              v-if="row.item.gerar_financeiro"
              type="file"
              accept="application/pdf,image/jpeg,image/png,.pdf,.jpg,.jpeg,.png"
              class="form-control-file"
              @change="row.item.comprovante_pagamento = $event.target.files[0] || null"
            />
          </template>
          <template #cell(data_faturamento)="row">
            <b-form-input
              v-model="row.item.data_faturamento"
              type="date"
              size="sm"
            />
          </template>
        </b-table>
      </div>

      <template #modal-footer="{ cancel }">
        <div>
          <b-button
            variant="primary"
            @click="faturarPedido"
            ref="faturarPedido"
            class="mr-5"
            :disabled="permitido_faturar"
          >
            Confirmar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <TableApp
      titulo="Pedidos"
      acaoBtn="/#/pedidos-novo"
      textoBtn="Novo Pedido"
      api-url="/pedido/lista"
      :fields="fieldsToShow"
      classFilterColumn="numero"
      ref="pedidosList"
      :perPage="10"
      :multiselect="true"
    >
      <template slot="customRow" scope="props">
        <span slot="numero" class="pl-0 pt-8" v-if="props.field == 'numero'">
          <div class="d-flex align-items-center">
            <div class="font-weight-bold text-muted">
              {{ props.rowData.numero }}
              <br />
              <p
                style="margin-bottom: 0rem; !important"
                v-if="props.rowData.sync_app"
                v-b-tooltip.right="'Pedido realizado no APP Nuts'"
              >
                <Mobile :size="15" />
              </p>
              <p
                class="pedido-origem-catalogo"
                v-if="isCatalogOrder(props.rowData)"
                v-b-tooltip.right="'Pedido realizado pelo Catálogo Digital'"
              >
                <CatalogWebsite :size="16" />
              </p>
              <p
                style="margin-bottom: 0rem; !important;"
                v-if="
                  props.rowData.pedido_compra && !isCatalogOrder(props.rowData)
                "
              >
                Ped. Compra: {{ props.rowData.pedido_compra }}
              </p>
            </div>
          </div>
        </span>
        <span slot="cliente" class="pl-0 pt-8" v-if="props.field == 'cliente'">
          <div class="d-flex align-items-center">
            <div class="font-weight-bold text-muted">
              {{ props.rowData.cliente }}
            </div>
          </div>
        </span>
        <span
          slot="vendedor"
          class="pl-0 pt-8"
          v-if="props.field == 'vendedor'"
        >
          <div class="d-flex align-items-center">
            <div class="font-weight-bold text-muted">
              {{ props.rowData.vendedor }}
            </div>
          </div>
        </span>
        <span
          slot="solicitante"
          class="pl-0 pt-8"
          v-if="props.field == 'solicitante'"
        >
          <div class="d-flex align-items-center">
            <div class="font-weight-bold text-muted">
              {{ props.rowData.solicitante }}
            </div>
          </div>
        </span>
        <span
          slot="status"
          v-if="props.field == 'status'"
          :class="statusPedidoClass(props.rowData.status)"
        >
          {{ statusPedidoLabel(props.rowData.status) }}
        </span>
        <span
          slot="dataValidade"
          class="pl-0 pt-8"
          v-if="props.field == 'dataValidade'"
        >
          <div
            class="d-flex align-items-center justify-content-end font-weight-bold text-muted"
          >
            {{ props.rowData.dataValidade | moment("DD/MM/YYYY") }}
          </div>
        </span>
        <span
          slot="created_at"
          class="pl-0 pt-8"
          v-if="props.field == 'created_at'"
        >
          <div
            class="d-flex align-items-center justify-content-end font-weight-bold text-muted"
          >
            {{ props.rowData.created_at | moment("DD/MM/YYYY") }}
          </div>
        </span>
        <span
          slot="valorTotal"
          v-if="props.field == 'valorTotal'"
          class="text-dark-75 font-weight-bolder d-block font-size-lg"
        >
          R$
          {{ numberToReal(props.rowData.valorTotal, 2) }}
        </span>

        <span
          slot="actions"
          v-if="props.field == 'actions'"
          class="text-dark-75 font-weight-bolder d-block font-size-lg"
        >
          <div class="action-buttons">
            <button
              v-if="checkImpressao(props.rowData)"
              @click="imprimirPedido(props.rowData)"
              v-b-tooltip.righttop="'Imprimir pedido'"
              class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
            >
              <PdfIcon :size="22" />
            </button>
            <button
              @click="editarPedido(props.rowData)"
              v-if="props.rowData.status !== 8 && props.rowData.status !== 12 && props.rowData.status !== 10"
              class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
              v-b-tooltip.righttop="'Editar Pedido'"
            >
              <PencilIcon :size="20" />
            </button>
            <button
              @click="shareToWhatsapp(props.rowData)"
              v-b-tooltip.righttop="'Encaminhar PDF para o whatsapp do cliente'"
              class="btn btn-sm btn-success btn-hover-success btn-icon mr-2"
            >
              <Whatsapp :size="20" />
            </button>
            <button
              @click="doCopy(props.rowData, props.rowData.id_pedido)"
              class="btn btn-sm btn-success btn-hover-success btn-icon mr-2"
              v-b-tooltip.hover.bottom="'Copiar Link'"
              placement="bottom"
            >
              <Link :size="16" />
            </button>
            <button
              @click="linkPedidoFaturado(props.rowData)"
              class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
              v-b-tooltip.bottom="'Pedido Faturado'"
              v-if="props.rowData.status == 12"
            >
              <Money :size="20" />
            </button>
            <button
              @click="excluir(props.rowData)"
              v-if="props.rowData.status == 1 && !store.pafNFCe"
              v-b-tooltip.hover.bottom="'Excluir pedido'"
              class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
            >
              <TrashCanIcon :size="20" />
            </button>
          </div>
        </span>
      </template>
    </TableApp>

    <b-modal id="atualizarStatus" title="Atualizar status" size="md" centered>
      <div class="mx-auto">
        <b-form class="form">
          <b-row>
            <b-col>
              <b-form-group label="Status" label-for="status">
                <b-form-select v-model="statusToUpdate" placeholder="">
                  <b-form-select-option
                    v-for="status in pedidoStatus"
                    :key="status.id"
                    :value="status.id"
                  >
                    {{ status.descricao }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button @click="cancel()"> Cancelar </b-button>
        <b-button variant="primary" ref="enviar_correcao" @click="salvarStatus">
          Salvar
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="estornarPedidoModal"
      title="Estornar pedido?"
      size="md"
      centered
    >
      <div class="mx-auto">
        <b-form class="form">
          <b-row>
            <b-col>
              Deseja estornar o pedido número:
              {{ actionsStore?.selectedRows[0]?.numero }}
            </b-col>
          </b-row>
        </b-form>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button @click="cancel()"> Cancelar </b-button>
        <b-button
          variant="primary"
          ref="estornar_pedido"
          @click="estornarPedido"
        >
          Salvar
        </b-button>
      </template>
    </b-modal>

    <SendToWppModal
      :data="dataToWhatsapp"
      :openModal="wppOpenModal"
      @handleOpenModal="(openModal) => (wppOpenModal = openModal)"
      module="pedidos"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TableApp from "@/components/Table/Table2";
import swal from "sweetalert";
import { SistemaMixin } from "@/modules/Application";
import flatPickr from "flatpickr";
import "flatpickr/dist/flatpickr.css";
import Whatsapp from "vue-material-design-icons/Whatsapp.vue";
import PdfIcon from "vue-material-design-icons/FilePdfBox.vue";
import PencilIcon from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import Link from "vue-material-design-icons/LinkPlus.vue";
import Mobile from "vue-material-design-icons/CellphoneCheck.vue";
import CatalogWebsite from "vue-material-design-icons/WebCheck.vue";

import "flatpickr/dist/themes/material_blue.css";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import FilterFields from "@/components/FilterFields";
import SendToWppModal from "@/components/SendToWppModal";
import Menu from "vue-material-design-icons/Menu";
import { actionsStore } from "@/components/Table/actionsStore";
import Money from "vue-material-design-icons/CashCheck.vue";
import { store } from "../storePedidos";
import ToggleSwitchOutline from "vue-material-design-icons/ToggleSwitchOutline.vue";
import InformationOutline from "vue-material-design-icons/InformationOutline.vue";
import ColumnVisibilitySidebar from "@/components/ColumnVisibility/ColumnVisibilitySidebar.vue";
import {
  createColumnVisibilityMixin,
  LIST_CONFIG_MODULES,
} from "@/components/ColumnVisibility/columnVisibilityMixin";

export default {
  name: "pedidos",
  mixins: [
    SistemaMixin,
    createColumnVisibilityMixin({
      moduleConfig: LIST_CONFIG_MODULES.PEDIDOS,
      sidebarId: "sidebar-pedidos-fields",
    }),
  ],
  components: {
    TableApp,
    ColumnVisibilitySidebar,
    PdfIcon,
    PencilIcon,
    Link,
    Whatsapp,
    TrashCanIcon,
    FilterFields,
    SendToWppModal,
    Menu,
    Money,
    Mobile,
    CatalogWebsite,
    ToggleSwitchOutline,
    InformationOutline,
  },
  data() {
    return {
      store,
      actionsStore,
      components: {
        flatPickr,
      },
      pedidoStatus: null,
      statusToUpdate: null,
      wppOpenModal: false,
      dataToWhatsapp: null,
      formasPagamento: [],
      fields: [
        {
          label: "Número",
          field: "numero",
          type: "text",
          slot: true,
          sortable: false,
        },
        {
          label: "Cliente",
          field: "cliente",
          type: "text",
          slot: true,
          sortable: false,
        },
        {
          label: "Vendedor",
          field: "vendedor",
          type: "text",
          slot: true,
          sortable: false,
        },
        {
          label: "Solicitante",
          field: "solicitante",
          type: "text",
          slot: true,
          sortable: false,
        },
        {
          label: "Data de Validade",
          field: "dataValidade",
          sortable: false,
          slot: true,
          type: "date",
          dateInputFormat: "yyyy-MM-dd HH:mm:ss",
          dateOutputFormat: "dd-MM-yyyy",
        },
        {
          label: "Data de Criação",
          field: "created_at",
          sortable: false,
          slot: true,
          type: "date",
          dateInputFormat: "yyyy-MM-dd HH:mm:ss",
          dateOutputFormat: "dd-MM-yyyy",
        },
        {
          label: "Valor",
          field: "valorTotal",
          sortable: false,
          slot: true,
          type: "text",
        },
        {
          label: "Status",
          field: "status",
          sortable: true,
          slot: true,
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          required: true,
        },
      ],
      gerar_financeiro: true,
      movimentar_estoque: true,
      permitido_faturar: false,
      data_faturamento: null,
      itensFaturamento: [],
      camposItensFaturamento: [
        { key: "numero", label: "Pedido" },
        { key: "movimentar_estoque", label: "Mov. Estoque" },
        { key: "gerar_financeiro", label: "Ger. Financeiro" },
        { key: "data_faturamento", label: "Data Faturamento" },
        { key: "comprovante_pagamento", label: "Comprovante" },
      ],
    };
  },
  async created() {
    try {
      const { data } = await this.$http.post("/pedido/status");
      this.pedidoStatus = data;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    atualizarPedidosCatalogo() {
      this.$refs.pedidosList?.refresh();
    },
    async buscarFormasPagamento() {
      const formasPagamento = await this.getFormasPagamentos();
      this.formasPagamento = Array.isArray(formasPagamento)
        ? formasPagamento
        : [];
    },

    isCatalogOrder(order) {
      if (!order) return false;
      if (order.catalogo_digital || order.origem_catalogo_digital) return true;

      const origin = String(order.origem || order.canal || "").toLowerCase();
      const syncUuid = String(order.uuid_sync || "").toLowerCase();
      return (
        ["catalogo", "catalogo_digital", "catalogo-digital"].includes(origin) ||
        syncUuid.indexOf("catalogo-digital:") === 0
      );
    },
    checkImpressao(pedido) {
      if (!this.store.pafNFCe) {
        return true;
      }

      if (pedido.status == 8) {
        return false;
      }

      return true;
    },
    async duplicar() {
      const { id_pedido } = this.actionsStore?.selectedRows[0];

      this.addLoadingToButton("doublePedido");

      try {
        await this.$http.post("/pedido/duplicar", {
          id_pedido,
        });
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Pedido duplicado com sucesso!");
        this.$refs.pedidosList.refresh();
        this.$bvModal.hide("duplicarPedido");
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("doubleOrcamento");
    },
    linkPedidoFaturado(data) {
      swal({
        title: "Deseja visualizar o Pedido faturado?",
        text: "Ao confirmar será aberto em nova aba o PDF",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        swal.close();
        swal.stopLoading();
        this.$copyText(data.link);
        if (data.link_faturamento) {
          window.open(data.link_faturamento, "_blank");
        }
        this.$toast.success("PDF gerado com sucesso!");
      });
    },
    inicializarItensFaturamento() {
      this.itensFaturamento = this.actionsStore.selectedRows.map((p) => ({
        id_pedido: p.id_pedido,
        numero: p.numero,
        gerar_financeiro: this.gerar_financeiro,
        movimentar_estoque: this.movimentar_estoque,
        data_faturamento: this.data_faturamento,
        comprovante_pagamento: null,
      }));
    },
    aplicarGlobalAosItens() {
      this.itensFaturamento.forEach((item) => {
        item.gerar_financeiro = this.gerar_financeiro;
        item.movimentar_estoque = this.movimentar_estoque;
        item.data_faturamento = this.data_faturamento;
      });
    },
    async faturarPedido() {
      const arquivoInvalido = this.itensFaturamento.some((item) => {
        const arquivo = item.comprovante_pagamento;
        return arquivo &&
          (!["application/pdf", "image/jpeg", "image/png"].includes(arquivo.type) ||
            arquivo.size > 10 * 1024 * 1024);
      });
      if (arquivoInvalido) {
        this.$toast.error("Selecione PDF, JPG/JPEG ou PNG de até 10 MB.");
        return;
      }
      const itensSemData = this.itensFaturamento.filter(
        (i) => !i.data_faturamento
      );
      if (itensSemData.length > 0) {
        this.$toast.warning(
          "Informe a data do faturamento para todos os pedidos!"
        );
        return;
      }

      this.addLoadingToButton("faturarPedido");

      try {
        const payload = new FormData();
        payload.append("gerar_financeiro", this.gerar_financeiro ? "1" : "0");
        payload.append("movimentar_estoque", this.movimentar_estoque ? "1" : "0");
        if (this.data_faturamento) payload.append("data_faturamento", this.data_faturamento);
        this.itensFaturamento.forEach((item, indice) => {
          payload.append(`itens[${indice}][id_pedido]`, item.id_pedido);
          payload.append(`itens[${indice}][gerar_financeiro]`, item.gerar_financeiro ? "1" : "0");
          payload.append(`itens[${indice}][movimentar_estoque]`, item.movimentar_estoque ? "1" : "0");
          payload.append(`itens[${indice}][data_faturamento]`, item.data_faturamento);
          if (item.gerar_financeiro && item.comprovante_pagamento) {
            payload.append(`itens[${indice}][comprovante_pagamento]`, item.comprovante_pagamento);
          }
        });
        const response = await this.$http.post("/pedido/faturar-lote", payload);

        const { sucesso, falhas } = response.data;

        // Abre os PDFs gerados.
        (sucesso || []).forEach((s) => {
          if (s.url_pedido_faturado) {
            window.open(s.url_pedido_faturado, "_blank");
          }
        });

        const totalOk = (sucesso || []).length;
        const totalFalhas = (falhas || []).length;

        if (totalFalhas > 0) {
          this.$toast.warning(
            `${totalOk} pedido(s) faturado(s). ${totalFalhas} com falha.`
          );
        } else {
          this.$toast.success("Pedido(s) faturado(s) com sucesso!");
        }

        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.actionsStore.selectedRows = [];
        this.$bvModal.hide("faturarPedido");
        this.data_faturamento = null;
        this.movimentar_estoque = true;
        this.permitido_faturar = null;
        this.itensFaturamento = [];
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("faturarPedido");
    },
    doCopy(data, id_pedido) {
      swal({
        title: "Deseja enviar o link para o cliente?",
        text: "Ao confirmar será copiado para a area de transferencia o link",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        swal.close();
        swal.stopLoading();
        this.$copyText(data.link);
        this.$toast.success("Link copiado com sucesso!");
      });
    },
    async estornarPedido() {
      const { id_pedido } = this.actionsStore?.selectedRows[0];

      this.addLoadingToButton("estornar_pedido");

      try {
        const response = await this.$http.post("/pedido/estornar-faturamento", {
          id_pedido,
        });

        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Pedido estornado com sucesso!");
        this.$bvModal.hide("estornarPedidoModal");
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("estornar_pedido");
    },
    salvarStatus() {
      this.$bvModal.hide("atualizarStatus");
      swal({
        title: "Deseja atualizar o(s) status do(s) pedido(s)?",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http.post("/pedido/update-status", {
          pedidos: actionsStore.selectedRows.map(({ id_pedido }) => ({
            id_pedido,
          })),
          status: this.statusToUpdate,
        });
        this.statusToUpdate = null;
        swal.close();
        swal.stopLoading();
        this.$refs.pedidosList.refresh();
      });
    },
    imprimirPedido(data) {
      swal({
        title: "Deseja imprimir o pedido?",
        text: "Aguarde, pois será gerado o PDF automaticamente!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/pedido/print", {
            id_pedido: data.id_pedido,
          })
          .then(({ data }) => {
            if (data.url_pedido) {
              window.open(data.url_pedido, "_blank");
            }
            swal.stopLoading();
            swal.close();
            this.$toast.success("Venda impressa com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    imprimirPedidoProducao() {
      const pedido = this.actionsStore?.selectedRows[0];

      if (!pedido) {
        return;
      }

      swal({
        title: "Deseja imprimir o pedido para produção?",
        text: "Aguarde, pois será gerado o PDF automaticamente!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/pedido/print-producao", {
            id_pedido: pedido.id_pedido,
          })
          .then(({ data }) => {
            if (data.url_pedido) {
              window.open(data.url_pedido, "_blank");
            }
            swal.stopLoading();
            swal.close();
            this.$toast.success("Pedido para produção impresso com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    async shareToWhatsapp(data) {
      this.dataToWhatsapp = data;
      this.wppOpenModal = true;
    },

    async editarPedido(data) {
      swal({
        title: "Deseja editar o Pedido?",
        text: "Você ira ser direcionado para a pagina de edição aguarde...",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }

        await this.$http
          .post("/pedido/find", {
            id_pedido: data.id_pedido,
          })
          .then((response) => {
            swal.stopLoading();
            swal.close();
            this.$toast.info("Você será redirecionado agora");
            this.$router.push({
              name: "pedidosNovo",
              params: {
                pedidoData: {
                  ...response.data,
                  pedidoId: response.data.id_pedido,
                },
              },
            });
          })
          .catch(() => {
            swal.stopLoading();
            this.$toast.error("Erro ao solicitar o endpoint do Pedido");
            swal.close();
          });
      });
    },

    excluir(data) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir o pedido?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/pedido/delete", {
              id_pedido: data.id_pedido,
            });
            this.$refs.pedidosList.refresh();
            this.$toast.success("Pedido excluído!");
          }
        });
    },
    formataPagamento(pagamento) {
      const pagamentos = JSON.parse(pagamento);
      var pagamentoFormatado = "";

      pagamentos.forEach((pag) => {
        if (pag.value == 0) {
          pagamentoFormatado = "Pedido sem valores para realizar faturamento.";
          this.permitido_faturar = true;
          return;
        }

        if (pag.value != 0 && pag.paymentMode.description) {
          this.permitido_faturar = false;
          pagamentoFormatado +=
            pag.paymentMode.description +
            ": R$ " +
            this.numberToReal(pag.value, 2);
        }
      });
      return pagamentoFormatado;
    },
  },

  dateRangeFilter(data, filterString) {
    let dateRange = filterString.split("to");
    let startDate = Date.parse(dateRange[0]);
    let endDate = Date.parse(dateRange[1]);
    return (data =
      Date.parse(data) >= startDate && Date.parse(data) <= endDate);
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    filterFields() {
      return [
        { type: "text", label: "Número", field: "numero" },
        { type: "text", label: "Cliente", field: "cliente" },
        { type: "text", label: "Vendedor", field: "vendedor" },
        { type: "text", label: "Solicitante", field: "solicitante" },
        { type: "date", label: "Dt.Validade", field: "dataValidade" },
        { type: "date", label: "Dt.Solicitação", field: "data_solicitacao" },
        { type: "date", label: "Dt.Criação", field: "created_at" },
        { type: "text", label: "Pedido de Compra", field: "pedido_compra" },
        { type: "text", label: "Valor", field: "valorTotal" },
        {
          type: "select",
          label: "Status",
          field: "status",
          options: [
            "Editando",
            "Autorizado",
            "Cancelado",
            "Exportado",
            "Importado NFE",
            "Produção",
            "Entregue/Concluído",
            "Faturado",
            "Aprovado",
            "Aguardando Aprovação",
          ],
        },
        {
          type: "select",
          label: "Forma de pagamento",
          field: "id_forma_pagamento",
          options: [
            { text: "Todas", value: null },
            ...this.formasPagamento.map((item) => ({
              text: item.descricao,
              value: item.id,
            })),
          ],
        },
      ];
    },
    config() {
      return this.layoutConfig();
    },
  },
  async mounted() {
    this.$root.$on("catalogo-digital:novos-pedidos", this.atualizarPedidosCatalogo);
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }

    let inputs = ['input[placeholder="Data"]'];
    inputs.forEach(function (input) {
      flatPickr(input, {
        dateFormat: "Y-m-d",
        allowInput: true,
        locale: Portuguese,
      });
    });

    await this.buscarFormasPagamento();
  },
  beforeDestroy() {
    this.$root.$off("catalogo-digital:novos-pedidos", this.atualizarPedidosCatalogo);
  },
};
</script>

<style>
.pedido-origem-catalogo {
  display: inline-flex;
  align-items: center;
  margin: 0 !important;
  color: var(--primary-color, #ee7361);
  cursor: help;
}

.flatpickr-months .flatpickr-month,
.flatpickr-current-month .flatpickr-monthDropdown-months,
.flatpickr-weekdays,
span.flatpickr-weekday {
  background: var(--primary-color) !important;
}

.headerColumn {
  text-align: start;
}

.flatpickr-calendar.arrowTop:before {
  border-bottom-color: var(--primary-color) !important;
  color: var(--primary-color) !important;
}
</style>
